import React from 'react';
interface PillProps {
  children: React.ReactNode;
  tone?: 'gold' | 'track' | 'outline';
  className?: string;
}
const tones: Record<string, string> = {
  gold: 'border-gold/40 bg-gold/10 text-gold-soft',
  track: 'border-track/50 bg-track/15 text-track',
  outline: 'border-line bg-graphite text-stone'
};
export function Pill({
  children,
  tone = 'gold',
  className = ''
}: PillProps) {
  return <span className={`inline-flex items-center rounded-full border px-4 py-1.5 font-sans text-[10px] font-semibold uppercase tracking-[0.2em] ${tones[tone]} ${className}`} data-id="element-143" data-mp="1avtqgp2b8kh7">
      {children}
    </span>;
}